import * as actionTypes from 'constants/ActionTypes';

const letters = (state = { pagination: {} }, action) => {
    switch (action.type) {
        case actionTypes.GET_LETTERS:
            return {
                ...state,
                ...action.data,
            };
        default:
            return state;
    }
};

export default letters;



// WEBPACK FOOTER //
// ./app/reducers/letters.js